export type ApiNotification = {
	id?: string
	type: API_NOTIFICATION_TYPE
	status: API_NOTIFICATION_STATUS
	message: string
	created: string
	data?: ApiNotificationData
	cover_url?: string
}

export type ApiNotificationData = {
	user_id?: string
	itinerary_id?: string
	task_id?: string
	invitation_code?: string
	invitation_url?: string
}

export enum API_NOTIFICATION_TYPE {
	TRIP_INVITATION_ACCEPTED = 'trip_invitation_accepted',
	TRIP_INVITATION_RECEIVED = 'trip_invitation_received',
	TASK_ASSIGNED = 'task_assigned',
	TRIP_DELETED = 'trip_deleted',
	TRIP_DATE_CHANGED = 'trip_date_changed',
	TRIP_TITLE_CHANGED = 'trip_title_changed',
	WALL_PIN_CREATED = 'wall_pin_created',
	WALL_PIN_DELETED = 'wall_pin_deleted',
	BOOKING_CREATED = 'booking_created',
	FAVORITE_SPOT_CREATED = 'favorite_spot_created',
}

export enum API_NOTIFICATION_STATUS {
	UNREAD = 'unread',
	READ = 'read',
}
